import gql from 'graphql-tag'

export const IMPORTAR_GRUPO_USUARIOS = gql`
  mutation ImportarGrupoUsuariosMutation {
    importarGrupoUsuarios
  }
`
